import React from 'react';
import {useTranslation} from 'react-i18next';
import {withStyles} from "@material-ui/core/styles";
import LanguageService from '@services/language/LanguageService';

const styles = theme => ({
    cursorPointer: {
        cursor: 'pointer'
    },
});

const LanguageSwitcher = ({classes}) => {
    const {i18n} = useTranslation();

    const handleLanguageChange = (lng) => {
        i18n.changeLanguage(lng);
        LanguageService.setLang(lng)
    };

    return (
        <>
            <select
                className={classes.cursorPointer}
                value={LanguageService.getLang() || 'ru'} onChange={(e) => handleLanguageChange(e.target.value)}
            >
                <option value="ru">🇷🇺 RU</option>
                <option value="en">🇬🇧 EN</option>
            </select>
        </>
    );
};

export default withStyles(styles)(LanguageSwitcher);
